import { useQuery } from '@tanstack/react-query';

import {
  individualsService,
  FetchIndividualsRequest,
  FetchIndividualsResponse,
  useToast,
} from '@aslanpay/portal-common-lib';

const useFetchAdminsPage = ({
  ids,
  status,
  companyId,
  friendlyId,
  payCalendarId,
  externalPayrollId,
  email,
  isTerminationDateSet,
  onUnpaidLeave,
  allowTracking,
  allowMarketing,
  query,
  sortBy,
  sort,
  page,
  size,
}: Omit<FetchIndividualsRequest, 'role'>) => {
  const toast = useToast();

  return useQuery<FetchIndividualsResponse, Error>(
    [
      'fetchAdminsPage',
      ids,
      status,
      companyId,
      friendlyId,
      payCalendarId,
      externalPayrollId,
      email,
      isTerminationDateSet,
      onUnpaidLeave,
      allowTracking,
      allowMarketing,
      query,
      sortBy,
      sort,
      page,
      size,
    ],
    () =>
      individualsService.fetchIndividuals({
        ids,
        status,
        role: ['ASLAN_ADMIN', 'COMPANY_ADMIN'],
        companyId,
        friendlyId,
        payCalendarId,
        externalPayrollId,
        email,
        isTerminationDateSet,
        onUnpaidLeave,
        allowTracking,
        allowMarketing,
        query,
        sortBy,
        sort,
        page,
        size,
      }),
    {
      onError: () => {
        toast({
          position: 'top-right',
          status: 'error',
          title: 'Something went wrong',
          description: `Sorry, we failed to fetch the admins${
            companyId?.length ? ' for this company' : ''
          }. Please try again.`,
        });
      },
    }
  );
};

export default useFetchAdminsPage;
